import { Link } from 'react-router-dom';
import { dualScreenData } from '@/mocks/mossteams';
import ConsultationForm from '@/components/ConsultationForm';

function DualScreenPage() {
  const heroIcons = [
    { icon: 'ri-device-line', label: '15.6" 双屏触控' },
    { icon: 'ri-mic-line', label: '360° 全向麦克风' },
    { icon: 'ri-translate', label: 'AI 同传' },
    { icon: 'ri-cast-line', label: '多点投屏' },
  ];

  const featureHighlights = dualScreenData.features.items.slice(0, 4);
  const featureGrid = dualScreenData.features.items.slice(4, 8);

  return (
    <>
      {/* Banner */}
      <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
        <div className="absolute inset-0 bg-primary-950/85 z-0" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50 z-[1]" />
        <div className="absolute inset-0 z-[1]">
          <img
            src="/images/banner-bg.jpg"
            alt="MossTeams 双屏机"
            className="w-full h-full object-cover object-top opacity-35"
          />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
          <div className="w-full max-w-3xl mx-auto">
            <span className="inline-block px-4 py-1.5 mb-6 text-xs md:text-sm font-medium text-white/80 border border-white/25 rounded-full backdrop-blur-sm">
              {dualScreenData.banner.tag}
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-4">
              {dualScreenData.banner.title}
            </h1>
            <p className="text-lg md:text-2xl text-white/80 font-light">
              {dualScreenData.banner.subtitle}
            </p>
            <div className="mt-8 translate-y-16 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={dualScreenData.cta.primary.href}
                className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-customer-service-2-line mr-2"></i>{dualScreenData.cta.primary.text}
              </a>
              <Link
                to={dualScreenData.cta.secondary.href}
                className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-file-download-line mr-2"></i>{dualScreenData.cta.secondary.text}
              </Link>
              <Link
                to={dualScreenData.cta.tertiary.href}
                className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-send-line mr-2"></i>{dualScreenData.cta.tertiary.text}
              </Link>
              <a
                href={dualScreenData.cta.jd.href}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-bag-line mr-2"></i>{dualScreenData.cta.jd.text}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA（已注释，按钮已移入顶部 Banner） */}
      {/* <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-primary-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">对 MossTeams 双屏机感兴趣？</h2>
          <p className="text-white/75 text-sm md:text-base mb-8">立即咨询产品详情、获取报价方案或下载技术白皮书</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={dualScreenData.cta.primary.href}
              className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-customer-service-2-line mr-2"></i>{dualScreenData.cta.primary.text}
            </a>
            <Link
              to={dualScreenData.cta.secondary.href}
              className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-download-line mr-2"></i>{dualScreenData.cta.secondary.text}
            </Link>
            <Link
              to={dualScreenData.cta.tertiary.href}
              className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-send-line mr-2"></i>{dualScreenData.cta.tertiary.text}
            </Link>
            <a
              href={dualScreenData.cta.jd.href}
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-bag-line mr-2"></i>{dualScreenData.cta.jd.text}
            </a>
          </div>
        </div>
      </section> */}

      {/* Hero Product Title + Icons */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="max-w-3xl mx-auto text-3xl md:text-5xl font-bold text-foreground-900 tracking-tight leading-tight mb-6">
            会议室专属 AI 秘书
          </h2>
          <p className="max-w-3xl mx-auto text-sm md:text-base text-foreground-600 leading-relaxed mb-10">
            {dualScreenData.overview.content}
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 md:gap-12 max-w-3xl mx-auto">
            {heroIcons.map((item, idx) => (
              <div key={idx} className="flex flex-col items-center">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-500 mb-3">
                  <i className={`${item.icon} text-2xl md:text-3xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-700">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Big Visual Showcase */}
      <section className="px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src="/images/mossteams/dual-screen/main.jpg"
              alt="MossTeams 双屏机全景展示"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </section>

      {/* Core Features — Alternating Split */}
      <section className="bg-background-100 py-16 md:py-24 px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">核心功能</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{dualScreenData.features.title}</h2>
          </div>

          {featureHighlights.map((f, idx) => (
            <div key={idx} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center mb-16 md:mb-24 ${idx === featureHighlights.length - 1 ? '' : ''}`}>
              <div className={`${idx % 2 === 1 ? 'lg:order-2' : ''} overflow-hidden rounded-2xl`}>
                <img
                  src={f.imageSrc}
                  alt={f.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className={`${idx % 2 === 1 ? 'lg:order-1 lg:pl-4' : 'lg:pr-4'}`}>
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                  <i className={`${f.icon} text-xl`}></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">{f.name}</h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{f.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {idx === 0 && (
                    <>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">发言人区分</span>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">在线分享</span>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">随时查阅</span>
                    </>
                  )}
                  {idx === 1 && (
                    <>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">140+ 语种</span>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">母语收听</span>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">全场景适配</span>
                    </>
                  )}
                  {idx === 2 && (
                    <>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">自动识别</span>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">实时播报</span>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">多样模式</span>
                    </>
                  )}
                  {idx === 3 && (
                    <>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">无遮挡</span>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">PPT 兼容</span>
                      <span className="px-3 py-1 bg-background-50 text-foreground-600 rounded-full text-xs">一键开启</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Feature Grid — 2x2 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {featureGrid.map((f, idx) => (
              <div key={idx} className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300">
                <div className="h-44 md:h-52 overflow-hidden">
                  <img
                    src={f.imageSrc}
                    alt={f.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                    <i className={`${f.icon} text-base`}></i>
                  </div>
                  <h4 className="text-sm font-bold text-foreground-900 mb-2">{f.name}</h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Room Solutions — Meeting Room Scenarios */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">全场景会议解决方案</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {dualScreenData.scenarios.items.map((s, idx) => (
              <div key={idx} className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-accent-200 transition-all duration-300">
                <div className="h-36 md:h-44 overflow-hidden">
                  <img
                    src={s.imageSrc}
                    alt={s.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-lg bg-accent-50 text-accent-500">
                      <i className={`${s.icon} text-sm`}></i>
                    </div>
                    <h4 className="text-sm font-bold text-foreground-900">{s.name}</h4>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-accent-600 bg-accent-50 rounded-full">核心优势</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-3">{dualScreenData.advantages.title}</h2>
            <p className="text-sm md:text-base text-foreground-500">{dualScreenData.advantages.subtitle}</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {dualScreenData.advantages.items.map((a, idx) => (
              <div key={idx} className="flex items-start gap-4 bg-white rounded-xl p-5 md:p-6 border border-background-200">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-50 text-accent-500">
                  <i className={`${a.icon} text-lg`}></i>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-foreground-900 mb-1.5">{a.name}</h4>
                  <p className="text-xs text-foreground-500 leading-relaxed">{a.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Specs */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{dualScreenData.specs.title}</h2>
          </div>
          <div className="bg-white rounded-2xl border border-background-200 overflow-hidden">
            <div className="divide-y divide-background-100">
              {dualScreenData.specs.rows.map((row, idx) => (
                <div key={idx} className={`flex flex-col sm:flex-row py-4 px-6 md:px-8 ${idx % 2 === 0 ? 'bg-background-50/50' : ''}`}>
                  <span className="text-xs font-semibold text-foreground-400 uppercase tracking-wider w-full sm:w-48 flex-shrink-0 mb-1 sm:mb-0">{row.label}</span>
                  <span className="text-sm text-foreground-800">{row.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{dualScreenData.related.title}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {dualScreenData.related.items.map((r, idx) => (
              <Link
                key={idx}
                to={r.href}
                className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="h-44 overflow-hidden">
                  <img
                    src={r.imageSrc}
                    alt={r.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <h4 className="text-sm font-bold text-foreground-900 mb-1">{r.name}</h4>
                  <p className="text-xs text-foreground-500">{r.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Consultation Form */}
      <ConsultationForm badge="商务咨询" title="在线咨询" subtitle="填写以下信息，我们的商务团队将在24小时内与您联系" />
    </>
  );
}

export default DualScreenPage;